"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../utils/constants");
var muiIdBack16 = {
    paths: [
        {
            path: 'M2,2 L2,10 L14,10 L14,2 L2,2 Z M0,1.00247329 C0,0.448822582 0.444630861,0 1.00087166,0 L14.9991283,0 C15.5518945,0 16,0.455760956 16,1.00247329 L16,10.9975267 C16,11.5511774 15.5468037,12 15.0026177,12 L0.996678026,12 C0.446227952,12 0,11.544239 0,10.9975267 L0,1.00247329 Z M1,3 L15,3 L15,5 L1,5 L1,3 Z M4,7 C4.55228475,7 5,7.44771525 5,8 C5,8.55228475 4.55228475,9 4,9 C3.44771525,9 3,8.55228475 3,8 C3,7.44771525 3.44771525,7 4,7 Z M11,7 C11.5522847,7 12,7.44771525 12,8 C12,8.55228475 11.5522847,9 11,9 C10.4477153,9 10,8.55228475 10,8 C10,7.44771525 10.4477153,7 11,7 Z M7,7 L8,7 C8.55228475,7 9,7.44771525 9,8 C9,8.55228475 8.55228475,9 8,9 L7,9 C6.44771525,9 6,8.55228475 6,8 C6,7.44771525 6.44771525,7 7,7 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'Back of ID',
    width: 16,
    height: 12,
};
var muiIdBack24 = {
    paths: [
        {
            path: 'M2,2 L2,16 L22,16 L22,2 L2,2 Z M0.909090909,0 L23.0909091,0 C23.5929861,0 24,0.407013864 24,0.909090909 L24,17.0909091 C24,17.5929861 23.5929861,18 23.0909091,18 L0.909090909,18 C0.407013864,18 0,17.5929861 0,17.0909091 L0,0.909090909 C0,0.407013864 0.407013864,0 0.909090909,0 Z M1,4 L23,4 L23,6 L1,6 L1,4 Z M4,10 L5,10 L5,14 L4,14 L4,10 Z M17,10 L18,10 L18,14 L17,14 L17,10 Z M19,10 L20,10 L20,14 L19,14 L19,10 Z M9,10 L11,10 L11,14 L9,14 L9,10 Z M14,10 L16,10 L16,14 L14,14 L14,10 Z M6,10 L8,10 L8,14 L6,14 L6,10 Z M12,10 L13,10 L13,14 L12,14 L12,10 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'Back of ID',
    width: 24,
    height: 18,
};
var muiIdBack = {
    base: muiIdBack16,
    smIcon: muiIdBack16,
    lgIcon: muiIdBack24,
};
exports.muiIdBack = muiIdBack;
//# sourceMappingURL=idBack.js.map